"use strict";
import { WETH9 } from "@uniswap/sdk-core";
import { getChainFromChainUrlParam, getChainUrlParam } from "constants/chains";
import {
  MATIC_MAINNET,
  USDC_ARBITRUM,
  USDC_BASE,
  USDC_MAINNET,
  USDC_OPTIMISM,
  USDC_POLYGON,
  USDT,
  WBTC,
  WETH_POLYGON
} from "constants/tokens";
import { Chain } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { UniverseChainId } from "uniswap/src/types/chains";
const moonPaySupportedChains = [Chain.Ethereum, Chain.Polygon, Chain.Arbitrum, Chain.Optimism, Chain.Base];
const isMoonpaySupportedChain = (chain) => !!chain && moonPaySupportedChains.includes(chain);
const CURRENCY_CODES = {
  [Chain.Ethereum]: {
    [WETH9[UniverseChainId.Mainnet]?.address.toLowerCase()]: "weth",
    [USDC_MAINNET.address.toLowerCase()]: "usdc",
    [USDT.address.toLowerCase()]: "usdt",
    [WBTC.address.toLowerCase()]: "wbtc",
    [MATIC_MAINNET.address.toLowerCase()]: "polygon",
    native: "eth"
  },
  [Chain.Arbitrum]: {
    [USDC_ARBITRUM.address.toLowerCase()]: "usdc_arbitrum",
    native: "eth_arbitrum"
  },
  [Chain.Optimism]: {
    [USDC_OPTIMISM.address.toLowerCase()]: "usdc_optimism",
    native: "eth_optimism"
  },
  [Chain.Polygon]: {
    [USDC_POLYGON.address.toLowerCase()]: "usdc_polygon",
    [WETH_POLYGON.address.toLowerCase()]: "eth_polygon",
    native: "matic_polygon"
  },
  [Chain.Base]: {
    [USDC_BASE.address.toLowerCase()]: "usdc_base",
    native: "eth_base"
  }
};
export function getDefaultCurrencyCode(address, gqlChain) {
  if (!gqlChain) {
    return "eth";
  }
  if (!address) {
    return isMoonpaySupportedChain(gqlChain) ? CURRENCY_CODES[gqlChain]?.native : "eth";
  }
  if (isMoonpaySupportedChain(gqlChain)) {
    const code = CURRENCY_CODES[gqlChain]?.[address.toLowerCase()];
    return code ?? "eth";
  }
  return "eth";
}
export function parsePathParts(pathname) {
  const pathParts = pathname.split("/");
  const chainSlug = getChainUrlParam(pathParts.length > 2 ? pathParts[pathParts.length - 2] : void 0);
  const chain = getChainFromChainUrlParam(chainSlug);
  const tokenAddress = pathParts.length > 2 ? pathParts[pathParts.length - 1] : void 0;
  return { chain, tokenAddress };
}
